import { fetchToken } from "../../common/FetchCookie"
import { ADMIN, BASE_URL, CONTACT_US } from "../../common/URLs"

const API_BASE_URL = `${BASE_URL}/${ADMIN}/${CONTACT_US}`

export const fetchContactUs = async () => {
    const url = `${API_BASE_URL}`
    try {
        const token = await fetchToken()

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        })

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

        const data = await response.json()
        return data.response || []
    } catch (error) {
        console.error("API Error:", error)
        return []
    }
}

export const updateContactUs = async (contactData) => {
    const url = `${API_BASE_URL}/${contactData.uuid}`
    try {
        const token = await fetchToken()

        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                status: contactData.status,
                reply_description: contactData.reply_description,
                reply_status: contactData.reply_status,
            }),
        })

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

        const data = await response.json()
        return data
    } catch (error) {
        console.error("API Error:", error)
        throw error
    }
}

export const deleteContactUs = async (uuid) => {
    const url = `${API_BASE_URL}/${uuid}`
    try {
        const token = await fetchToken()

        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        })

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

        const data = await response.json()
        return data
    } catch (error) {
        console.error("API Error:", error)
        throw error
    }
}
